import TaskForm from './task-form';
import {SaveButton} from '@/components/refinedev/action_buttons';
import EditForm from '@/components/refinedev/pages/edit-form';

const TaskEdit = () => {
  return (
    <EditForm
      transformBeforeSave={TaskForm.transformBeforeSave}
      formProps={{
        refineCoreProps: {
          meta: {
            with: ['members'],
          },
        },
        // defaultValues: TaskForm.defaultValues,
      }}>
      <div className="mx-auto flex flex-col gap-y-4 ">
        <TaskForm />
        <SaveButton size="lg" className="self-end" />
      </div>
    </EditForm>
  );
};

export default TaskEdit;
